import { useState, useEffect } from "react";

const convertImageToWebP = async (imageUrl) => {
  try {
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = function (event) {
        const img = new Image();
        img.src = event.target.result;
        img.onload = function () {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          canvas.toBlob((webpBlob) => {
            resolve(URL.createObjectURL(webpBlob));
          }, "image/webp", 0.8);
        };
      };
    });
  } catch (error) {
    console.error("خطا در دانلود یا تبدیل تصویر:", error);
    return imageUrl; 
  }
};

const WebPImage = ({ src, alt }) => {
  const [webpSrc, setWebpSrc] = useState(null);

  useEffect(() => {
    const processImage = async () => {
      const newSrc = await convertImageToWebP(src);
      setWebpSrc(newSrc);
    };

    if (src) processImage();
  }, [src]);

  return <img className="img-fluid" src={webpSrc || src} alt={alt} />;
};

export default WebPImage;
